/**
*
* LoadingSpinner
*
*/

import LoadingSpinner from './LoadingSpinner.jsx'
import './LoadingSpinner.less'

export default LoadingSpinner